import { authService } from '../auth/auth.service';
import { getActiveRoles, hasSingleStore } from '../auth/authHelpers';
import sessionService from '../sessionMonitor/session.service';
import storeService from './store.service';
import { useStoreGuid } from '@/lib/hooks';
import { useStores } from '@/lib/hooks/useStores';
import { urlService } from '@whiz-cart/ui-shared/url/url.service';
import { useEffect } from 'react';

if (!urlService.getUrl().params.storeGuid) {
    const remembered = localStorage.getItem('storeGuid');
    if (remembered) urlService.replaceUrl({ storeGuid: remembered || undefined }, urlService.getUrl().hash);
}

export default () => [
    urlService.state
        .map((url) => url.params?.storeGuid)
        .subscribe((storeGuid) => {
            localStorage.setItem('storeGuid', storeGuid ?? '');

            if (getActiveRoles(authService.loginState.get(), undefined, storeGuid)().has('admin')) {
                sessionService.setDefaultDemoMode(true);
            } else sessionService.setDefaultDemoMode(false);
        }),

    authService.loginState
        .map((state) => state.isLoggedIn)
        .subscribe((isLoggedIn) => {
            if (!isLoggedIn) return;

            // Tenant roles resolve through the store list, which is not loaded yet after a reload
            void storeService
                .allStores()
                .get()
                .catch(() => undefined)
                .then(() => {
                    const storeGuid = urlService.state.get().params.storeGuid;
                    sessionService.setDefaultDemoMode(getActiveRoles(authService.loginState.get(), undefined, storeGuid)().has('admin'));
                });
        }),
];

export function useRedirectToStore() {
    const { stores, isLoaded } = useStores();
    const { storeGuid } = useStoreGuid();

    useEffect(() => {
        // The store list is fetched after startup; checking against the empty list would reset any storeGuid
        if (!isLoaded) return;

        const arrayStores = Object.keys(stores);
        const haveAcces = storeGuid ? arrayStores.includes(storeGuid ?? '') : !hasSingleStore();

        if (!haveAcces) {
            const lastStore = [...(urlService.history.location.state?.returnLocationStack ?? [])]
                .reverse()
                .map(({ location }) => urlService.parse(location.search.substring(1)).storeGuid)
                .find((guid) => arrayStores.includes(guid));
            if (lastStore) {
                urlService.pushUrl({ storeGuid: lastStore }, urlService.getUrl().hash);
            } else {
                urlService.pushUrl({ storeGuid: arrayStores[0] }, urlService.getUrl().hash);
            }
        }
    }, [storeGuid, isLoaded]);
}
